import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../axiosInstance';
import {
  Grid,
  Typography,
  Button,
  TextField,
  Box,
  Snackbar,
  Alert
} from '@mui/material';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const handleSubmit = async () => {
    if (!email.trim()) {
      setSnackbar({ open: true, message: 'Please enter your email address.', severity: 'warning' });
      return;
    }

    try {
      setLoading(true);
      // ✅ Call your Django backend API
      const response = await axiosInstance.post('/api/send-password-reset/', { email });

      setSnackbar({
        open: true,
        message: response.data?.message || 'Reset link sent successfully!',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.error || 'Failed to send reset link.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f4f6f8',
        padding: 2
      }}
    >
      <Grid
        container
        sx={{
          maxWidth: '500px',
          backgroundColor: '#fff',
          boxShadow: '0px 10px 30px rgba(0,0,0,0.1)',
          borderRadius: '12px',
          padding: { xs: 3, sm: 4 },
          textAlign: 'center'
        }}
      >
        <Grid item xs={12} sx={{ mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
            Forgot Password
          </Typography>
          <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
            Enter your email address and we'll send you instructions to reset your password.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Email address"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              mb: 2,
              '& .MuiInputBase-root': {
                backgroundColor: '#f9f9f9',
                borderRadius: '8px',
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sx={{ mb: 2 }}>
          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            onClick={handleSubmit}
            sx={{
              backgroundColor: '#4285F4',
              color: '#fff',
              fontWeight: 'bold',
              padding: '12px 0',
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#357ae8' }
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </Grid>

        <Grid item xs={12}>
          <Typography
            component={Link}
            to="/login"
            variant="subtitle2"
            sx={{
              textDecoration: 'none',
              color: '#4285F4',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Back to Login
          </Typography>
        </Grid>
      </Grid>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ForgotPasswordPage;
